<template>
  <div>
    <section>
      <v-parallax src="/images/price_top.jpeg" height="460">
        <v-row align-content="center" class="position-relative">
          <v-row class="text-center mt-15 mt-sm-10 mb-5 mb-sm-12 full-width">
            <v-col class="pa-1">
              <h1 class="text-xs-center pretopia-head-font pretopia-display-3 white--text text-shadow">
                {{ $t('vendorPrice.title') }}
              </h1>
              <h2 class="text-center py-3 white--text text-shadow">
                {{ $t('vendorPrice.subtitle') }}
              </h2>
            </v-col>
          </v-row>
        </v-row>
      </v-parallax>
    </section>

    <v-container style="margin-top: -140px">
      <v-row class="mt-5">
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">BASIC</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4"
              >{{ $t('vendorPrice.package.basic.title') }}</v-card-text
            >
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">{{ $t('vendorPrice.package.basic.value1') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.basic.value2') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.basic.value3') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.basic.value4') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.basic.value5') }}</li>
              </ul>
            </v-card-text>
            <div class="flex-grow-1"></div>
            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="signupVendorContactUs('basic')">{{ $t('vendorPrice.contactUs') }}</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic">
              <div v-html="$t('vendorPrice.package.basic.price')"></div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <div class="price-badge absolute px-10 py-1 rounded-pill text-body-2">{{ $t('vendorPrice.package.standard.mostPopular') }}</div>
            <v-card-title class="pt-6 justify-center">STANDARD</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4"
              >{{ $t('vendorPrice.package.standard.title') }}</v-card-text
            >
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value1') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value2') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value3') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value4') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value5') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value6') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value7') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value8') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.standard.value9') }}</li>
              </ul>
            </v-card-text>
            <div class="flex-grow-1"></div>
            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="signupVendorContactUs('standard')">{{ $t('vendorPrice.contactUs') }}</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic">
              <div v-html="$t('vendorPrice.package.standard.price')"></div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">PREMIUM</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4">{{ $t('vendorPrice.package.premium.title') }}</v-card-text>
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value1') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value2') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value3') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value4') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value5') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value6') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value7') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value8') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value9') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premium.value10') }}</li>
              </ul>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="signupVendorContactUs('premium')">{{ $t('vendorPrice.contactUs') }}</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic">
              <div v-html="$t('vendorPrice.package.premium.price')"></div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">PREMIUM +</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4">{{ $t('vendorPrice.package.premiumPlus.title') }}</v-card-text>
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value1') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value2') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value3') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value4') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value5') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value6') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value7') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value8') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value9') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.premiumPlus.value10') }}</li>
              </ul>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="signupVendorContactUs('premium_plus')">{{ $t('vendorPrice.contactUs') }}</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic">
              <div v-html="$t('vendorPrice.package.premiumPlus.price')"></div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">GRANDE</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4">{{ $t('vendorPrice.package.grande.title') }}</v-card-text>
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value1') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value2') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value3') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value4') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value5') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value6') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value7') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value8') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value9') }}</li>
                <li class="pb-2">{{ $t('vendorPrice.package.grande.value10') }}</li>
              </ul>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="signupVendorContactUs('grande')">{{ $t('vendorPrice.contactUs') }}</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic">
              <div v-html="$t('vendorPrice.package.grande.price')"></div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-9">
        <v-col class="mb-10">
          <div v-html="$t('vendorPrice.info')"></div>

          <h3 class="mt-3 mb-4" v-html="$t('vendorPrice.infoTitle')"></h3>
          <p><router-link to="contactus">{{ $t('vendorPrice.contactUsLinkText') }}</router-link></p>
        </v-col>
      </v-row>
    </v-container>

    <signup-vendor-contactus-dialog-component
      :visible="showVendorSignupContactUsDialog"
      :packetName="selectedPacketName"
      @close="signupVendorClosed()"
    ></signup-vendor-contactus-dialog-component>
  </div>
</template>

<script>
import SignupVendorDialogComponent from '../../components/dialog/SignupVendorDialogComponent.vue';
import SignupVendorContactusDialogComponent from '../../components/dialog/SignupVendorContactUsDialogComponent.vue';

export default {
  components: {
    SignupVendorDialogComponent,
    SignupVendorContactusDialogComponent,
  },
  data() {
    return {
      showVendorSignupDialog: false,
      showVendorSignupContactUsDialog: false,
      selectedPacketName: '',
    };
  },

  mounted() {
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },

  methods: {
    signupVendor() {
      this.showVendorSignupDialog = true;
    },

    signupVendorContactUs(selectedPacket) {
      this.selectedPacketName = selectedPacket;
      this.showVendorSignupContactUsDialog = true;
    },

    signupVendorClosed() {
      this.showVendorSignupDialog = false;
      this.showVendorSignupContactUsDialog = false;
    },
  },
};
</script>

<style scoped>
.price-badge {
  position: absolute;
  top: -16px;
  transform: translateX(50%);
  right: 50%;
  border: 1px solid #d1bf89 !important;
  background-color: #efe2b9 !important;
}
.text-shadow {
  text-shadow: 2px 2px 6px black;
}
</style>
